import Image from 'next/image'

import {
  ScreenSize,
  SOMETHING_WENT_WRONG,
  SOMETHING_WENT_WRONG_DESCRIPTION
} from '@/app/constants/index'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'

import EmptyListPlug from './EmptyListPlug'

type Props = {
  buttonName?: string
  withGoToMainButton?: boolean
  onButtonClick?: () => void
  titleClassName?: string
}

const SomethingWentWrong = ({
  buttonName,
  withGoToMainButton = true,
  onButtonClick,
  titleClassName
}: Props) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <EmptyListPlug
        image={
          <Image
            src="/images/shared/something-went-wrong.png"
            width={isMobileScreen ? 90 : 120}
            height={isMobileScreen ? 90 : 120}
            alt="image"
          />
        }
        title={SOMETHING_WENT_WRONG}
        description={
          <span className="block max-w-[330px] sm:max-w-[260px]">
            {SOMETHING_WENT_WRONG_DESCRIPTION}
          </span>
        }
        withGoToMainButton={withGoToMainButton}
        className="mt-0"
        titleClassName={cn(
          'mb-32 text-24',
          'sm:mb-4 xxs:text-16',
          titleClassName
        )}
        descriptionClassName="text-grey-60 text-20 sm:text-16"
        buttonClassName="sm:mt-18"
        onButtonClick={() =>
          onButtonClick ? onButtonClick() : location.assign('/')
        }
        buttonName={buttonName}
      />
    </div>
  )
}

export default SomethingWentWrong
